module.exports = __webpack_public_path__ + "img/top.b46fed56.png";